// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__12E6m","signatureBlock":"Footer_signatureBlock__M1f9G","signature":"Footer_signature__7gd7u"};